import { useMemo } from 'react';

/** Substring/predicate filter. `q` handed to matchFn is pre-trimmed+lowercased.
 *  Empty query returns `items` unchanged. Tag/tier/sort logic stays in callers. */
export function useFilteredList<T>(
  items: T[],
  query: string,
  matchFn: (item: T, q: string) => boolean,
): T[] {
  return useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((it) => matchFn(it, q));
  }, [items, query, matchFn]);
}
